/**
 * State of the contacts
 *
 * @export
 * @class State
 */
export class State {
	loading: boolean;
	contacts: any;
}

export const initialState: State = {
	loading: false,
	contacts: null
};
